import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action, select, Store} from '@ngrx/store';

import {FunktionsbereichAnlegenRequest} from '../../../clients/benutzerverwaltung';
import {Observable} from 'rxjs';
import {
    GET_FUNKTIONSBEREICH_FREIGABE_ROLLEN,
    GetFunktionsbereicheAction,
    GetFunktionsbereichFreigabeRollenAction,
    GetFunktionsbereichRollenAction,
    POST_FUNKTIONSBEREICH_ANLEGEN,
    POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_ERFOLGREICH,
    POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_ERFOLGREICH,
    POST_FUNKTIONSBEREICH_LOESCHEN,
    POST_ROLLE_LOESCHEN_ERFOLGREICH,
    PostFunktionsbereichAnlegenAction
} from '../../../client-ngrx/benutzerverwaltung';
import * as uiActions from './funktionsbereiche-rollen.actions.ui';
import {map, withLatestFrom} from 'rxjs/operators';
import {MITTEILUNGS_VORLAGE_SPEICHERN, MitteilungsVorlageSpeichernAction} from './funktionsbereiche-rollen.actions.ui';
import {getMitteilungsVorlageDetail, PageState} from './funktionsbereiche-rollen.reducer';
import {PostMitteilungsVorlageAktualisierenAction, PostMitteilungsVorlageAnlegenAction} from '../../../client-ngrx/kommunikation';
import {MitteilungsVorlageDatenRequest} from '../../../clients/kommunikation';
import {UuidService} from '@orga-app/providers/uuid.service';

@Injectable()
export class FunktionsbereichRollenPageUiEffects {
    /**
     * This effect does not yield any actions back to the store. Set
     * `dispatch` to false to hint to @ngrx/effects that it should
     * ignore any elements of this effect stream.
     *
     * The `defer` observable accepts an observable factory function
     * that is called when the observable is subscribed to.
     * Wrapping the database op
     * en call in `defer` makes
     * effect easier to test.ty
     */

    @Effect()
    funktionsbereichLoeschenEerfolgreich$: Observable<Action> = this.actions$.pipe(
        ofType(POST_FUNKTIONSBEREICH_LOESCHEN)
        , map(() => {
            return new GetFunktionsbereicheAction();
        })
    );
    private funktionsbereichAnlegenRequest: FunktionsbereichAnlegenRequest = null;
    @Effect()
    rolleLoeschenErfolgreich$: Observable<Action> = this.actions$.pipe(
        ofType(POST_ROLLE_LOESCHEN_ERFOLGREICH)
        , map(() => {
            // TODO V3 - funktioniert das?

            // return new GetFunktionsbereichRollenAction(this.rolleLoeschenRequest.funktionsbereich_id);
            return new GetFunktionsbereichRollenAction(this.funktionsbereichId);
        })
    );
    private funktionsbereichId: string = null;
    @Effect()
    funktionsbereichAnlegen$: Observable<Action> = this.actions$.pipe(
        ofType(POST_FUNKTIONSBEREICH_ANLEGEN)
        , map((x: PostFunktionsbereichAnlegenAction) => {
            this.funktionsbereichAnlegenRequest = x.funktionsbereichAnlegenRequest;
            this.funktionsbereichId = x.funktionsbereichAnlegenRequest.funktionsbereich_id;
            return new uiActions.AktuellenFunktionsbereichZwischengespeichert();
        })
    );
    @Effect()
    funktionsbereichFreigabeRollenLaden$: Observable<Action> = this.actions$.pipe(
        ofType(GET_FUNKTIONSBEREICH_FREIGABE_ROLLEN)
        , map((x: GetFunktionsbereichFreigabeRollenAction) => {
            this.funktionsbereichId = x.funktionsbereich_id;
            return new uiActions.AktuellenFunktionsbereichZwischengespeichert();
        })
    );
    @Effect()
    funktionsbereichFreigabeRolleHinzugefuegtErfolgreich$: Observable<Action> = this.actions$.pipe(
        ofType(POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_HINZUFUEGEN_ERFOLGREICH)
        , map(() => {
            return new GetFunktionsbereichFreigabeRollenAction(this.funktionsbereichId);
        })
    );
    @Effect()
    funktionsbereichFreigabeRolleEntferntErfolgreich$: Observable<Action> = this.actions$.pipe(
        ofType(POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_ERFOLGREICH)
        , map(() => {
            return new GetFunktionsbereichFreigabeRollenAction(this.funktionsbereichId);
        })
    );

    @Effect()
    mitteilungsVorlageSpeichern$: Observable<Action> = this.actions$.pipe(
        ofType<MitteilungsVorlageSpeichernAction>(MITTEILUNGS_VORLAGE_SPEICHERN)
        , withLatestFrom(this.store.pipe(select(getMitteilungsVorlageDetail)))
        , map(([x, detail]) => {
            const request: MitteilungsVorlageDatenRequest = {
                mitteilungs_vorlage_id: detail.mitteilungs_vorlage_id,
                beschreibung: detail.beschreibung,
                titel: detail.titel,
                rolle_id: detail.rolle_id,
            };
            if (detail.mitteilungs_vorlage_id === null) {
                request.mitteilungs_vorlage_id = this.uuid.generateUUID();
                return new PostMitteilungsVorlageAnlegenAction(request);
            } else {
                return new PostMitteilungsVorlageAktualisierenAction(request);
            }

        })
    );

    constructor(private actions$: Actions,
                private uuid: UuidService,
                private store: Store<PageState>) {
    }
}
